import {createRouter, createWebHashHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import contact from "@/views/Contact";

function lazyLoad(view) {
    return () => import(`@/views/${view}.vue`)
}

const routes = [
    {
        path: '/',
        name: 'home',
        props: true,
        component: HomeView,
        meta: {
            title: "Hendri Nagelholt | HN Accountancy - Boekhouding & Belastingadvies"
        }
    },
    {
        path: '/diensten',
        name: 'Diensten',
        props: true,
        component: lazyLoad('Diensten'),
        meta: {
            title: "Diensten van HN Accountancy"
        }
    },
    {
        path: '/diensten/fiscaal',
        name: 'Fiscaal',
        props: true,
        component: lazyLoad('diensten/Fiscaal'),
        meta: {
            title: "Fiscaal | HN Accountancy"
        }
    },
    {
        path: '/diensten/advies',
        name: 'Advies',
        props: true,
        component: lazyLoad('diensten/Advies'),
        meta: {
            title: "Advies | HN Accountancy"
        }
    },
    {
        path: '/diensten/administratie',
        name: 'Administratie',
        props: true,
        component: lazyLoad('diensten/Administratie'),
        meta: {
            title: "Administratie | HN Accountancy"
        }
    },
    {
        path: '/diensten/interim',
        name: 'Interim',
        props: true,
        component: lazyLoad('diensten/Interim'),
        meta: {
            title: "Interim | HN Accountancy"
        }
    },
    {
        path: '/diensten/accountancy',
        name: 'Accountancy',
        props: true,
        component: lazyLoad('diensten/Accountancy'),
        meta: {
            title: "Accountancy | HN Accountancy"
        }
    },
    {
        path: '/contact',
        name: 'Contact',
        props: true,
        component: contact,
        meta: {
            title: "Contact | HN Accountancy"
        }
    },
    {
        path: '/over-mij',
        name: 'About',
        props: true,
        component: lazyLoad('About'),
        meta: {
            title: "Over mij | HN Accountancy"
        }
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})


router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title}`;
    next();
})

export default router
